export const idEstadoRebate = {
  aprobadoPorCategory: 1,
  aprobado: 2,
  aprobadoPorSeller: 3,
  rechazado: 6
}

export const switchCardRebate = (estado) => {
  let title, color;

  switch (estado) {
    case "Activo":
      title = "Rebate Activo";
      color = "verde";
      break;
    case "En revision":
      title = "Rebate En Revisión";
      color = "lila";
      break;
    case "Pendiente":
      title = "Rebate Pendiente";
      color = "rojo";
      break;
    case "Rechazado":
      title = "Rebate Rechazado";
      color = "gris";
      break;
    case "Finalizado":
    case "Eliminado":
    case null:
      title = "Rebate Finalizado";
      color = "gris";
      break;
    default:
      title = "";
      color = "";
      break;
  }

  return { title, color }
}